import * as React from 'react';
import { getEntryPorts } from "src/api/shipmentExecution";
import { useFieldProps } from "src/hooks/form/useField";
import { useSelect } from "src/hooks/form/useSelect";
import useApi from '../useApi';

const useEntryPort = <T>(
  props: useFieldProps<T>,
) => {
  const ports = useApi(getEntryPorts);
  const field = useSelect(
    props,
    getEntryPorts,
    (data) => data?.map(dataMap) || [],
  );

  React.useEffect(() => {
    if (ports.status === 'FINISHED') {
      field.setOptions(ports.data?.map(dataMap) || []);
    }
  }, [ports.status]);

  const dataMap = (item) => ({
    key: item.displayName,
    label: item.displayName,
    ...item,
  });

  return {
    ...field,
  };
};

export default useEntryPort;
